var offsetX = 0;
var offsetY = -2.0;
var width = 50;
var height = 70;
var rotate = 0;
var marginX = 2.0;
var marginY = 2.0;
var titleFontSize = 5.6;
var titleWidth = width - marginX * 2;
var titleHeight = 7.4;

var sheetHeight = 5.5;

var contentWidth = width - marginX * 3;
var contentHeight = 4.3;
var fontSize = 3;

var qrCodeHeight = height - marginY * 28;
var qrCodeWidth = qrCodeHeight;
//文本打印数据
export const textPrintData = {
  InitDrawingBoardParam: {
    width: width,
    height: height,
    rotate: rotate,
    path: "ZT001.ttf",
    verticalShift: 0,
    HorizontalShift: 0,
  },

  elements: [
    {
      type: "text",
      json: {
        x: marginX + offsetX,
        y: marginY * 2 + offsetY,
        height: titleHeight,
        width: titleWidth,
        value: "二手机入库标签",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: titleFontSize,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [true, false, false, false],
      },
    },
    {
      type: "text",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 5.5 + offsetY,
        height: contentHeight,
        width: contentWidth,
        value: "型号：iPhone 13ProMax",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: 4,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [false, false, false, false],
      },
    },
    {
      type: "text",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 5.5 + sheetHeight + offsetY,
        height: contentHeight,
        width: contentWidth,
        value: "内存：256GB",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: 4,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [false, false, false, false],
      },
    },
    {
      type: "text",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 5.5 + sheetHeight * 2 + offsetY,
        height: contentHeight,
        width: contentWidth,
        value: "电量：98%",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: 4,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [false, false, false, false],
      },
    },
    {
      type: "text",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 5.5 + sheetHeight * 3 + offsetY,
        height: contentHeight,
        width: contentWidth,
        value: "卡槽状态：双卡槽",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: fontSize,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [false, false, false, false],
      },
    },
    {
      type: "text",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 5.5 + sheetHeight * 4 + offsetY,
        height: contentHeight,
        width: contentWidth,
        value: "颜色：蓝色",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: fontSize,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [false, false, false, false],
      },
    },
    {
      type: "text",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 5.5 + sheetHeight * 5 + offsetY,
        height: contentHeight,
        width: contentWidth,
        value: "成色：99新",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: fontSize,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [false, false, false, false],
      },
    },
    {
      type: "text",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 5.5 + sheetHeight * 6 + offsetY,
        height: contentHeight,
        width: contentWidth,
        value: "屏电情况：原屏原电",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: fontSize,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [false, false, false, false],
      },
    },
    {
      type: "text",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 5.5 + sheetHeight * 7 + offsetY,
        height: contentHeight,
        width: contentWidth,
        value: "序列号：KDOWSOSK",
        fontFamily: "宋体",
        rotate: 0,
        fontSize: fontSize,
        textAlignHorizonral: 0,
        textAlignVertical: 1,
        letterSpacing: 0.0,
        lineSpacing: 1.0,
        lineMode: 6,
        fontStyle: [false, false, false, false],
      },
    },
    {
      type: "qrCode",
      json: {
        x: marginX * 1.5 + offsetX,
        y: marginY * 5.5 + sheetHeight * 8 + offsetY,
        height: qrCodeHeight,
        width: qrCodeWidth,
        value: "SMFP366Q1HW",
        codeType: 31,
        rotate: 0,
        fontSize: fontSize,
        textHeight: fontSize,
        textPosition: 0,
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./src/utils/printData/Text.js